import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  get isProduction(): boolean {
    return environment.production;
  }

  getStripePublishableKey(): string {
    return environment.stripePublishableKey;
  }
}
